export enum Stage {
    BETA = 'BETA',
    PRODUCTION = 'PRODUCTION',
}